<script lang="ts">
  //Images are statically imported to make sure Vite can encode and include them in the build file!

  import OnePersonMattressImage from "../../assets/icons/one-person-mattress.svg";
  import OnePersonMattressSelectedImage from "../../assets/icons/one-person-mattress-selected.svg";
  import TwoPersonMattressImage from "../../assets/icons/two-person-mattress.svg";
  import TwoPersonMattressSelectedImage from "../../assets/icons/two-person-mattress-selected.svg";
  import TwoOnePersonMattressesImage from "../../assets/icons/two-one-person-mattresses.svg";
  import TwoOnePersonMattressesSelectedImage from "../../assets/icons/two-one-person-mattresses-selected.svg";

  import BodyTypeIImage from "../../assets/icons/i.svg";
  import BodyTypeXImage from "../../assets/icons/x.svg";
  import BodyTypeYImage from "../../assets/icons/y.svg";

  import BodyTypeISelectedImage from "../../assets/icons/i-selected.svg";
  import BodyTypeXSelectedImage from "../../assets/icons/x-selected.svg";
  import BodyTypeYSelectedImage from "../../assets/icons/y-selected.svg";

  import {createEventDispatcher} from "svelte";
  import {t, translationExists} from "../../stores/translations";

  export let question;
  export let properties = {};

  const imageMapping = {
    x: BodyTypeXImage,
    y: BodyTypeYImage,
    i: BodyTypeIImage,
    "x-selected": BodyTypeXSelectedImage,
    "y-selected": BodyTypeYSelectedImage,
    "i-selected": BodyTypeISelectedImage,
    "one-person-mattress": OnePersonMattressImage,
    "two-person-mattress": TwoPersonMattressImage,
    "two-one-person-mattresses": TwoOnePersonMattressesImage,
    "one-person-mattress-selected": OnePersonMattressSelectedImage,
    "two-person-mattress-selected": TwoPersonMattressSelectedImage,
    "two-one-person-mattresses-selected": TwoOnePersonMattressesSelectedImage,
  };

  const dispatch = createEventDispatcher();
  export let selectedId: number;

  /**
   * Set the selected value and dispatch the select event.
   *
   * @param answer
   */
  function select(answer) {
    dispatch("select", answer);
  }

  function getImgSrc(answer): string {
    const key =
      answer.id === selectedId ? answer.slug + "-selected" : answer.slug;

    return imageMapping[key];
  }
</script>

<div class={question.slug}>
  {#each question.answers as answer}
    <div
      class:selected={selectedId === answer.id}
      on:click={() => select(answer)}
            on:keydown={() => select(answer)}
      style={properties.styling}
    >
      <input id={question.slug} type="radio" name={question.slug} />

      <img
        src={getImgSrc(answer)}
        alt={`Icon for the ${question.slug} question`}
      />

      <label for={question.id} class:selected={selectedId === answer.id}>
        {#if $translationExists(`questions.${question.slug}.labels.${answer.slug}`)}
          {$t(`questions.${question.slug}.labels.${answer.slug}`)}
        {/if}

        <p>
          {$t(`questions.${question.slug}.answers.${answer.slug}`)}
        </p>
      </label>
    </div>
  {/each}
</div>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  [class^="body-type"] {
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem 0;
  }

  .video-container {
    width: 100%;
    margin-bottom: 0.5rem;

    & > video {
      border-radius: 8px;
      width: inherit;
    }
  }

  div {
    & > div {
      display: flex;
      align-items: center;
      height: fit-content;
      padding: 1rem 1.5rem;
      background-color: $color-secondary;
      border-radius: 4px;
      cursor: pointer;

      &.selected {
        background-color: $color-primary;

        & > label {
          color: $color-white;
        }
      }

      & > input {
        display: none;
      }

      & > img {
        height: inherit;
        margin-right: 2rem;
        width: 60px;
      }

      & > label {
        font-family: "Roboto";
        font-size: $font-size-medium;
        font-weight: $font-weight-bold;
        line-height: 1.5rem;
        color: $color-text;
        margin: auto 0;

        & > p {
          font-weight: $font-weight-normal;
          margin: 0.5rem 0 0;
        }
      }
    }
  }

  @include desktop {
    [class^="body-type"] {
      margin-top: 0.5rem;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      grid-column-gap: 1rem;
      grid-row-gap: 1rem;
      padding: 0.5rem 0;

      div {
        height: 198px;
        box-sizing: border-box;

        img {
          height: 120px;
        }

        label {
          font-size: $font-size-large;

          p {
            font-size: $font-size-medium;
          }
        }
      }
    }

    div.mattress-type {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 0.5rem;

      div {
        height: 174px !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        flex: 1;

        img {
          height: 70px;
          margin: 0;
          width: auto;
        }

        label {
          margin: 0;
        }
      }
    }
  }
</style>
